import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { getHasGlobalFilterDurationChangedFromDefault } from '@modules/dashboard/helpers';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { useGetFeedDuration } from '@modules/feed/hooks';
import { parseStringifiedDuration } from '@modules/feed/utils/parseStringifiedDuration';
import { AnalysisViewFragment, Status } from 'generated/graphql';
import { DashboardAnalysisSubtitleContent } from './DashboardAnalysisSubtitleContent';

interface DashboardFeedHeaderSubtitleProps {
  analysis: AnalysisViewFragment;
}

export const DashboardFeedHeaderSubtitle = ({
  analysis,
}: DashboardFeedHeaderSubtitleProps) => {
  const globalFilterDuration = useDashboardStore(({ query }) => query.duration);
  const status = useAnalysisStore(({ status }) => status);

  const feedDuration = useGetFeedDuration();

  const hasGlobalFilterDurationChangedFromDefault =
    getHasGlobalFilterDurationChangedFromDefault(globalFilterDuration);

  if (status === Status.Invalid) {
    return null;
  }

  if (!feedDuration) {
    return null;
  }

  const duration = hasGlobalFilterDurationChangedFromDefault
    ? feedDuration
    : parseStringifiedDuration(feedDuration);

  return (
    <DashboardAnalysisSubtitleContent
      duration={duration}
      hasGlobalFilterDurationChangedFromDefault={
        hasGlobalFilterDurationChangedFromDefault
      }
    />
  );
};
